var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from 'lit/decorators.js';
import { html } from 'lit';
import { BwElement } from './base/bw-element.js';
let BwTag = class BwTag extends BwElement {
    constructor() {
        super(...arguments);
        this.tone = 'default';
        this.variant = 'tinted';
        this.size = 'md';
    }
    render() {
        return html `<span class="bw-tag-inner"><slot></slot></span>`;
    }
    firstUpdated() {
        // Light DOM has no native slot projection — move author children into
        // .bw-tag-inner. See B-054 / BwElement.projectSlots().
        this.projectSlots();
    }
};
__decorate([
    property({ type: String, reflect: true })
], BwTag.prototype, "tone", void 0);
__decorate([
    property({ type: String, reflect: true })
], BwTag.prototype, "variant", void 0);
__decorate([
    property({ type: String, reflect: true })
], BwTag.prototype, "size", void 0);
BwTag = __decorate([
    customElement('bw-tag')
], BwTag);
export { BwTag };
//# sourceMappingURL=bw-tag.js.map